import React from 'react'
import InteriorContainer from './InteriorContainer'

const Interior = props => (
  <InteriorContainer data-test="component-configurator-design-interior" {...props} />
)

export default Interior
